<template>
  <main class="plan-change settings">
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <section class="retry-area" v-if="responseError">
        <h3 class="retry-area__ttl">通信に失敗しました</h3>
        <a href="javascript:void(0);" @click="getUserSettings" class="btn-retry btn-retry--short">リトライ</a>
      </section>
      <div v-else>
        <section class="label-link-area">
          <h2 class="label-link-area__ttl">ご利用中のプラン</h2>
          <div class="label-link-area__main">
            <section class="current-plan">
              <h3 class="current-plan__ttl" v-if="userSettings">
                {{usingPlan.name_plan}}
                <span v-if="userSettings.unlimited_using_plan.purchase_date && userSettings.unlimited_using_plan.expires_date">
                  （{{userSettings.unlimited_using_plan.purchase_date | dateFormat}}~{{userSettings.unlimited_using_plan.expires_date | dateFormat}}）
                </span>
              </h3>
              <p class="current-plan__sentence" v-if="usingPlan.product_id !== 'free' && userSettings.unlimited_using_plan.auto_renewal === 1">お客さまのプランは {{userSettings.unlimited_using_plan.expires_date | dateFormat}} に自動更新され、¥{{usingPlan.amount_price}} が請求されます。</p>
              <p class="current-plan__sentence" v-else-if="usingPlan.product_id !== 'free' && userSettings.unlimited_using_plan.auto_renewal === 0">お客さまのプランは {{userSettings.unlimited_using_plan.expires_date | dateFormat}} に解約されます。</p>
              <p class="current-plan__sentence" v-else>{{usingPlan.description_text}}</p>
              <div class="plan-choice__bottom" v-if="usingPlan.product_id !== 'free' && userSettings.unlimited_using_plan.auto_renewal === 1">
                <span @click="onClickCancel()" class="plan-choice__btn" >Unlimitedを解約する</span>
              </div>
            </section>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
  import Loading from '../common/Loading.vue';
  import moment from 'moment';

  export default {
    title: 'プラン変更 | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: 'プラン変更',
    description: 'abceed のプラン変更はこちら',
    keywords: 'toeic,abceed,globee,プラン',
    headerType: 'historyBackNotSearch',
    components: {
      appLoading: Loading
    },
    data() {
      return {
        usingPlan: "",
        subscriptions: [],
        responseError: false,
      }
    },
    created() {
      this.getUserSettings();
    },
    methods: {
      getUserSettings() {
        this.$store.dispatch("changeLoadingCondition", true);
        this.$store.dispatch('getUserSettings', {token:""})
          .then(data => {
            this.responseError = data === 'error';
            this.$store.dispatch("changeLoadingCondition", false);
            if (this.responseError) return;
            this.usingPlan = data.unlimited_using_plan;
          }).catch(() => {
            this.$store.dispatch("changeLoadingCondition", false);
          });
      },
      onClickCancel() {
        if (!confirm('Unlimitedを解約してもよろしいですか？')) {
          return;
        }
        this.$store.dispatch("showLightBox", "loading");
        this.$store.dispatch("cancelUnlimited", {}).then(data => {
          //解約成功
          this.$store.dispatch("setAutoRenewal", 0);
          this.$store.dispatch("hideLightBox");
          this.$store.dispatch("showLightBox", "cancelUnlimitedResult");
        }).catch(err => {
          this.$store.dispatch("hideLightBox");
          alert('解約に失敗しました。');
        });
      }
    },
    computed: {
      userSettings() {
        return this.$store.getters.userSettings;
      },
      isLoading() {
        return this.$store.getters.isLoading;
      }
    },

  }
</script>



// WEBPACK FOOTER //
// src/components/settings/UnlimitedPlanChange.vue